
import { Grid, Paper } from '@mui/material';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../shared/state/root-reducer';

export function PaymentSuccessView() {

  const stateFields = {
    configId: useSelector(
      (state: RootState) =>
        state.guestContext.configId
    ),
    selectedEncounter : useSelector((state: RootState) => state.patientContext.selectedEncounter)
  };

  const { configId, selectedEncounter} = stateFields;

  useEffect(() => {
    if (!configId) {
      window.location.href = window.location.href.substring(0, window.location.href.indexOf('/webpayment'));
    }
  }, [
    configId
  ]);

  return (
    <>
        <>
          <Grid container direction="row">
            <Grid
              item
              direction="column"
              md={12}
              xs={12}
              style={{
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Paper
                style={{
                  maxWidth: "800px",
                  marginLeft: "auto",
                  marginRight: "auto",
                  marginBottom: "10px",
                  marginTop: "0.5em",
                  padding: "34px 35px 50px 35px"
                }}
              >
                <Grid container direction="row" spacing={1}>
                  <Grid
                    item
                    direction="column"
                    xs={12}
                    md={12}
                    style={{
                    paddingTop: "0.8em",
                    paddingBottom: "0.2em",
                    fontWeight: "bold",
                    fontSize: "1.5em"
                    }}
                  >
                    Thank you for your payment!
                  </Grid>
                </Grid>
                <Grid container direction="row" spacing={1}>
                    <Grid
                      item
                      direction="column"
                      xs={12}
                      md={12}
                      style={{
                        paddingTop: "1em",
                        fontSize: "1.2em",
                        lineHeight: "1.5em"
                      }}
                    >
                      <>Need more flexibility with future bills ?<br />
                        {`Contact ${selectedEncounter?.client?.clientName ? selectedEncounter?.client?.clientName : "your healthcare provider" } to ask about setting up an interest-free payment plan.`} </>
                    </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </>
    </>
  );
}

